<template>
  <div class="more-container main-w">
    <!-- 面包屑 -->
    <Crumbs>
      <template v-slot:current> 查看更多 </template>
    </Crumbs>
    <!-- 新闻 -->
    <More
      :title="title"
      :news-list="certList"
      :page-show="pageShow"
      @currentPage="currentPage"
      @toDetail="toDetail"
    >
      <template v-slot:icon>
        <img src="@/assets/panel_icon.png" alt="" />
      </template>
    </More>
  </div>
</template>

<script>

import Crumbs from '@/components/Crumbs'
import More from '@/components/More'
export default {
  components: { Crumbs, More },
  data() {
    return {
      title: '证书资讯',
      certList: {},
      formData: {
        page: 1,
        pagesize: 9
      },
      pageShow: true
    }
  },
  methods: {
    // 获取行业新闻
    async getCertList() {
      const { data } = await this.service1('News/newsList', { classid: 1, ...this.formData }, 'post')
      this.certList = data
    },
    // 切换分页
    currentPage(page) {
      this.formData.page = page
      this.getCertList()
    },
    // 跳转详情页
    toDetail(id, content, url) {
      if (content === '') {
        window.location.href = url
      } else {
        this.$router.push({ name: 'Detail', params: { id: id } })
      }
    }

  },
  created() {
    this.getCertList()
  }

}
</script>

<style lang="less" scoped>
.more-container {
  padding: 10px 23px;
  box-sizing: border-box;
  background-color: #fff;
}
</style>